import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Request from '../request';
import Preload from '../../../preload';
import Canvas from '../print/canvas';
import store from '../../../../store/store';
import { setPre, setTextError, resetTicket } from '../../../../store/actions';
import { PrintBox } from '../../../utils/style';
import { resetScanPolicyStore } from '../../../../../../../logic/store/pullstate/scanPolicy';
import CanvasPhonePre from './canvasPhonePre';

const { dispatch } = store;

function PhonePrint(props) {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const {
    ticket, config, preEntry, style, startScreen,
  } = useSelector((state) => state);
  const [needPrint, setNeedPrint] = useState(true);
  const [preEntryAllert, setPreEntryAllert] = useState(null);
  const navigate = useNavigate();
  const { errorUrl } = config;

  const sendPhone = async () => {
    try {
      const res = await Request(
        '/server/public/preorder/createTicketFromPreorder',
        'no',
        {
          data: {
            clientPhone: ticket.clientPhone,
            satellite_id: +ticket.satellite_id,
            zone_id: ticket.zone_id,
          },
        },
      );

      // Ошибка приложения приходит как 2xx с телом { error }. Сервер формулирует
      // текст про пин-код, поэтому для поиска по телефону показываем свой текст.
      if (res.data && res.data.error) {
        navigate(errorUrl);
        dispatch(setTextError('По указанному номеру телефона предварительная запись не найдена. Обратитесь к администратору.'));
        dispatch(resetTicket());
        return;
      }

      if (!res.data.style) {
        navigate(errorUrl);
        dispatch(setTextError('Не создан стиль для талона. Обратитесь к администратору.'));
        dispatch(resetTicket());
        return;
      }

      setData(res.data);
      setIsLoading(false);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      navigate(errorUrl);
      dispatch(setTextError('Нет связи с сервером. Обратитесь к администратору.'));
      dispatch(resetTicket());
    }
  };

  useEffect(() => {
    if (config.twoScreen) navigate(startScreen);
    if (preEntry.service) {
      setData(preEntry);
      setIsLoading(false);
    } else if (ticket.clientPhone) {
      sendPhone();
    } else {
      setIsLoading(false);
    }
    return () => {
      dispatch(setPre({}));
      resetScanPolicyStore();
    };
  }, []);

  const getServerParams = async () => {
    try {
      const newParams = await Request('/server/public/getTicketPrintMode/', 'get', {});
      const {
        data: { are_tickets_printed: areTicketsPrinted, pa_allowed_time_before: paAllowedTimeBefore },
      } = newParams;
      setPreEntryAllert(paAllowedTimeBefore);
      setNeedPrint(areTicketsPrinted !== 0);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('e === ', e);
    }
  };

  useEffect(() => {
    if (!isLoading) {
      getServerParams();
    }
  }, [isLoading]);

  function getCanvas() {
    if (isLoading || preEntryAllert === null) {
      return (<Preload print />);
    }

    if (!data.ticket) {
      return (
        <CanvasPhonePre
          dispatch={dispatch}
          errorUrl={errorUrl}
          {...props}
          config={config}
          data={data}
          needPrint={needPrint}
          style={props?.style}
          startScreen={startScreen}
          preEntryAllert={preEntryAllert}
        />
      );
    }

    return (
      <Canvas
        dispatch={dispatch}
        errorUrl={errorUrl}
        {...props}
        config={config}
        data={data}
        needPrint={needPrint}
      />
    );
  }

  return (
    <PrintBox style={{ background: style.body.background }}>
      {getCanvas()}
    </PrintBox>
  );
}

function compareProps(prevProps, nextProps) {
  return JSON.stringify(prevProps) === JSON.stringify(nextProps);
}

export default React.memo(PhonePrint, compareProps);
